import { Injector } from "@angular/core";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodeSubstanceAlias } from "../Entity/TreeNodeSubstanceAlias";
import { TreeNodeSubstanceAliasTranslationsList } from "./TreeNodeSubstanceAliasTranslationsList";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeSubstanceAliasList extends Art57NodeList {
    constructor(injector: Injector, parent: Art57Node) {
      super(injector, new ListView(), 'Substance Aliases ({param})');
      this.parent = parent;
      this.labelNodeName = 'Substance Aliases';      
    }
  
    override refreshLabel(): void {
      this.label = this.labelTemplate.replace(
        '{param}',
        this.getLabelParamFromChildren()
      );
    }
  
    override createChildTemplate(): Art57Node[] | null {
      let nodeCreated = new TreeNodeSubstanceAlias(this.ioc!, this);
      this.children?.push(nodeCreated);
  
      let art57NodesTemplate: Art57Node[] = [];
      art57NodesTemplate.push(
        new TreeNodeSubstanceAliasTranslationsList(this.ioc!, nodeCreated)
      );
  
      art57NodesTemplate.map((nodeToAdd) => {
        nodeCreated.children?.push(nodeToAdd);
      });
      this.refreshLabel();
  
      return [nodeCreated];
    }
  
    override getMessage(): any {
      let substancealiases: any[] = [];
      this.children?.forEach((node) => {
        let child = node as Art57Node;
        substancealiases.push(child.getMessage());
      });
      if (substancealiases.length > 0) {
        return { substancealiases: { substancealias: substancealiases } };
      } else {
        return undefined;
      }
    }
  
    override getHeaders(): string[] {
      return ['Source', 'Alias Name'];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node|undefined {
      let clonedNode: TreeNodeSubstanceAliasList = new TreeNodeSubstanceAliasList(
        this.ioc!,
        newParent
      );
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      this.children?.forEach((child) => {
        let childToClone = child as Art57Node;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      return clonedNode;
    }
  }